import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {BboZawodnik} from '../classess/bbo-zawodnik';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Cezar} from '../classess/cezar';


@Injectable({
  providedIn: 'root'
})
export class CezarService {

  cezar: Cezar[];
  baseUrl = 'https://ozbs.olsztyn.pl/services';

  constructor(private http: HttpClient) { }

  getAll(): Observable<Cezar[]> {
    return this.http.get(`${this.baseUrl}/cezar.php`).pipe(
      map((res) => {
        this.cezar = res['data'];
        return this.cezar;
      }),
      catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.log(error);
    return throwError('Error! something went wrong.');
  }

}
